import React from 'react'
import { CustomHeader } from '../../../../common'

export const HeaderOperation = ({ useFetchInit }) => {

    const { Actions, FetchData } = useFetchInit
    const { handleClickReturnToOperation } = Actions
    const { fetchSpecificOperation } = FetchData
    const { dataSpecificOperation } = fetchSpecificOperation

    const customFields = [
        { 
            label: 'Fecha',
            value: dataSpecificOperation[0]?.fecha_operacion || ''
        },
        {
            label: 'Caja',
            value: dataSpecificOperation[0]?.caja || '',
            md: 8
        },
        {
            label: 'Tipo',
            value: dataSpecificOperation[0]?.currency_type || ''
        },
        {
            label: 'Categoría',
            value: dataSpecificOperation[0]?.categoria || ''
        },
        {
            label: 'Usuario',
            value: dataSpecificOperation[0]?.nombre_usuario || '',
            secondaryValue: dataSpecificOperation[0]?.username || ''

        }
    ]

    return (
        <CustomHeader
            backLabel="Volver a operaciones"
            // onBack={handleClickReturnToOperation}
            customFields={customFields}
        />
    )
}
